import React from 'react'

interface Props {
  children: React.ReactNode
}

export function WorkspaceEditorMenuWrapper({ children }: Props) {
  return (
    <div className="border-border bg-card shadow-xs flex items-center gap-2 rounded-lg border px-1 py-1">
      {children}
    </div>
  )
}
